import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
// import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
// import * as XLSX from 'xlsx-style';
// import {
//     EndpointSalesReports,
//     createAPIEndpointSalesReports,
// } from "../../../Services/ReportsAll/SalesReportService";
import Axios from "../../../api/Axios";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { handleExportExcelloading } from "../../../Services/GlobalFunc/downloadExcel";

const LoadingReport = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingExcelinv, setLoadingExcelinv] = useState(false);
    const [gridInvoiceData, setGridInvoiceData] = useState([]);
    const [selectInvData, setSelectInvData] = useState([]);

    const Invrpt = "SalesReport/LoadingReportInvoices?";
    const Invrptdownload = "SalesReport/LoadingReportDownload";

    //   /api/SalesReport/LoadingReportInvoices
    const handleGetInvExcel = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        try {
            let daycount = Math.round(
                (tDate.getTime() - fDate.getTime()) / (1000 * 3600 * 24)
            );
            if (daycount > 10) {
                toast.warning("More Than 10 days Selection Not Allowed", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            } else {
                setLoadingExcelinv(true);
                const InvrptApi = `${Invrpt}CompId=${auth.CompId}&FromDate=${fromDateRange}&ToDate=${toDateRange}`;
                let dataresponse = await Axios.get(InvrptApi);
                setGridInvoiceData(dataresponse.data);
                setLoadingExcelinv(false);
            }
        } catch (error) {
            setLoadingExcelinv(false);
            console.log(error);
        }
    };
    const handleExportExcel = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let uniqueNo = `LoadingReport${GetDateFormat()}.xlsx`;
        try {
            setLoadingExcel(true);
            let invlst = selectInvData.map((item) => `${item.INVH_NO}`).join(",");
            // console.log(invlst);
            let Payload = {
                CompId: auth.CompId,
                fromDate: fromDateRange,
                toDate: toDateRange,
                invoiceslst: invlst,
            };
            let dataresponse = await Axios.post(Invrptdownload, JSON.stringify(Payload), {
                headers: { "Content-Type": "application/json" },
            });
            if (dataresponse?.data?.length == 0) {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            } else {
                handleExportExcelloading(dataresponse?.data?.Table1,dataresponse?.data?.Table2, uniqueNo);
                setSelectInvData([]);
                setLoadingExcel(false);
            }
        } catch (error) {
            setLoadingExcel(false);
            console.log(error);
        }
    };


    
    //     const summaryData = [
    //       {
    //         'Product Code': '3394144',
    //         'Product Name': 'CRB TURBO+ 15W-40, 15L MK 15.0000 LT',
    //         'Lot No': '2016001',
    //         'Pack Size': 15,
    //         'MRP': '',
    //         'Quantity In Ltr': 30,
    //         'Quantity In Pack': 2,
    //         'Cases to Load': 2,
    //         'Packs to Load': 0,
    //       },
    //     ];
    
    //     const detailsData = [
    //       {
    //         'Product Code': '3394144',
    //         'Product Name': 'CRB TURBO+ 15W-40, 15L MK 15.0000 LT',
    //         'Invoice No': 'INVH/000092',
    //         'Invoice Date': '21/04/2025',
    //         'Lot No': '2016001',
    //         'Pack Size': 15,
    //         'MRP': '',
    //         'Quantity In Ltr': 30,
    //         'Quantity In Pack': 2,
    //         'Cases to Load': 2,
    //         'Packs to Load': 0,
    //       },
    //     ];
    
    //     const workbook = XLSX.utils.book_new();
    
    //     const createStyledSheet = (data, title) => {
    //       const sheet = XLSX.utils.json_to_sheet(data, { origin: 'A3' });
    
    //       XLSX.utils.sheet_add_aoa(sheet, [[title]], { origin: 'A1' });
    //       XLSX.utils.sheet_add_aoa(sheet, [[title.includes("Summary") ? "Summary Data" : "Details Data"]], { origin: 'A2' });
    
    //       // Merge first row
    //       sheet['!merges'] = [
    //         { s: { r: 0, c: 0 }, e: { r: 0, c: Object.keys(data[0]).length - 1 } },
    //       ];
    
    //       // Apply green styling to the title cell
    //       const titleCell = sheet['A1'];
    //       titleCell.s = {
    //         fill: {
    //           fgColor: { rgb: 'C6EFCE' }, // Light green background
    //         },
    //         font: {
    //           bold: true,
    //           color: { rgb: '006100' }, // Dark green text
    //           sz: 14,
    //         },
    //         alignment: {
    //           horizontal: 'center',
    //           vertical: 'center',
    //         },
    //       };
    
    //       return sheet;
    //     };
    
    //     const summarySheet = createStyledSheet(summaryData, 'Pick List Report - 22 Apr 2025 (Summary)');
    //     const detailsSheet = createStyledSheet(detailsData, 'Pick List Report - 22 Apr 2025 (Details)');
    
    //     XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');
    //     XLSX.utils.book_append_sheet(workbook, detailsSheet, 'Details');
    
    //     XLSX.writeFile(workbook, 'PickList_Report.xlsx');
    //   };
    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">Loading Report</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary me-3"
                                    onClick={handleGetInvExcel}
                                    disabled={loadingExcelinv}
                                >
                                    {loadingExcelinv ? "Loading..." : "Get Invoices"}{" "}
                                    {loadingExcelinv ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleExportExcel}
                                    disabled={loadingExcel || selectInvData.length == 0}
                                >
                                    {loadingExcel ? "Loading..." : "Download"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </section>

            <section>
                <h3 className="py-2">Records</h3>
                <div className="DataTable">
                    <DataTable
                        value={gridInvoiceData}
                        rows={10}
                        filterDisplay="row"
                        // showGridlines
                        stripedRows
                        scrollHeight="80vh"
                        scrollable
                        paginator
                        selection={selectInvData}
                        onSelectionChange={(e) => setSelectInvData(e.value)}
                        selectionMode="checkbox"
                    >
                        <Column
                            selectionMode="multiple"
                            header="Select All"
                            headerStyle={{ width: "5rem" }}
                        ></Column>
                        <Column
                            field="INVH_NO"
                            header="Invoice No."
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder="Search Here..."
                        ></Column>
                        <Column field="INVH_DATE" header="Invoice Date"></Column>
                        <Column field="CUST_NAME" header="Customer Name"></Column>
                    </DataTable>
                </div>
            </section>
        </div>
    );
};

export default LoadingReport;
